import styled from "styled-components"
import { mobile } from "../../Responsive"

export const Container = styled.div`
    height: 100vh;
    scroll-snap-align: center;
    position: relative;
    overflow: hidden;
    z-index: 0;
`

export const Wrapper = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    z-index: 3;
`

export const Overlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    z-index: 2;
`
export const Image = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 1;
`

export const Title = styled.h1`
    color: var(--lightGrey);
    margin: 0;
`

export const Text = styled.p`
    color: var(--lightGrey);
    margin-top: 1rem;
    width: 70%;
    max-width: 800px;

    ${mobile({ width: "90%" })}
`